import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { NameDirectoryPreferenceOption } from '../models/name-directory-preference-option';
import { nameDirectoryPreferenceOptionActions } from '../state/name-directory-preference-option.actions';
import { nameDirectoryPreferenceOptionSelectors } from '../state/name-directory-preference-option.reducer';

@Directive({
    selector: '[ndtNameDirectoryPreferenceSelect]',
    standalone: false
})
export class NameDirectoryPreferenceSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<NameDirectoryPreferenceOption>,
      private statusService: NgrxEagerSelectService<AppState, NameDirectoryPreferenceOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            nameDirectoryPreferenceOptionActions,
            nameDirectoryPreferenceOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('nameDirectoryPreference', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
